import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../../assets/images/team-dude.svg';
const _hoisted_1 = { class: "flex flex-col items-center pt-12" };
const _hoisted_2 = { class: "mb-60 mt-13" };
const _hoisted_3 = { class: "flex" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    class: "mr-20 w-35"
}, null, -1);
const _hoisted_5 = { class: "text-sm font-light text-primary-900 max-w-86 dark:text-gray-300" };
const _hoisted_6 = { class: "mb-8" };
const _hoisted_7 = { class: "flex justify-end gap-8 mt-12" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('views.workspaces.delete')
};
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, ref } from 'vue';
import NeedHelp from '@/components/NeedHelp.vue';
import SectionHeading from '@/components/base/headings/SectionHeading.vue';
import DeleteWorkspaceDialog from '../DeleteWorkspaceDialog.vue';
import ContractTermEnds from '@/components/pricing/ContractTermEnds.vue';
import { FEATURE_FLAGS } from '@/constants';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Content',
    props: {
        workspace: null
    },
    setup(__props) {
        const props = __props;
        const isPricingEnabled = FEATURE_FLAGS.PRICING_ENABLED;
        const isWorkspaceFree = computed(() => store.getters.isFreeWorkspace);
        const router = useRouter();
        const store = useStore();
        const showConfirmDialog = ref(false);
        const cancel = () => router.push({ name: 'editWorkspace', params: { workspaceId: props.workspace.id } });
        const showDialog = () => {
            showConfirmDialog.value = true;
        };
        const hideDialog = () => {
            showConfirmDialog.value = false;
        };
        const handleDeleteWorkspace = () => {
            store.dispatch('deleteWorkspace');
        };
        return (_ctx, _cache) => {
            const _component_PillButton = _resolveComponent("PillButton");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(DeleteWorkspaceDialog, {
                    show: showConfirmDialog.value,
                    onConfirm: handleDeleteWorkspace,
                    onCancel: hideDialog
                }, null, 8, ["show"]),
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(SectionHeading, {
                        heading: _ctx.$t('title')
                    }, null, 8, ["heading"]),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('confirmation_text')), 1),
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('warning_text')), 1)
                            ])
                        ]),
                        (_unref(isPricingEnabled) && !_unref(isWorkspaceFree))
                            ? (_openBlock(), _createBlock(ContractTermEnds, {
                                key: 0,
                                date: __props.workspace.subscriptionPeriodEnd
                            }, null, 8, ["date"]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_PillButton, {
                                kind: "secondary",
                                onClick: cancel
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('cancel')), 1)
                                ], undefined, true),
                                _: 1
                            }),
                            _createVNode(_component_PillButton, { onClick: showDialog }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('delete')), 1)
                                ], undefined, true),
                                _: 1
                            })
                        ])
                    ]),
                    _createVNode(NeedHelp)
                ])
            ], 64));
        };
    }
});
